import { render, staticRenderFns } from "./copyCrudModal.vue?vue&type=template&id=0068a5be&"
import script from "./copyCrudModal.vue?vue&type=script&lang=js&"
export * from "./copyCrudModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports